import { LeafletEventHandlerFnMap } from "leaflet";
import { Polyline, PolylineProps } from "react-leaflet";

type Props = {
  positions: PolylineProps["positions"];
  color: string;
  eventHandlers?: LeafletEventHandlerFnMap;
};

/**
 * The line of a routed track: in the track's color with a white and a shadow outline. Also shows a saved track
 * until its route arrives.
 */
export const RoutablePolyline = ({
  positions,
  color,
  eventHandlers,
}: Props) => (
  <>
    <Polyline
      pathOptions={{ color: "black", weight: 10, opacity: 0.2 }}
      positions={positions}
      eventHandlers={eventHandlers}
    />
    <Polyline
      pathOptions={{ color: "white", weight: 8, opacity: 0.8 }}
      positions={positions}
      eventHandlers={eventHandlers}
    />
    <Polyline
      pathOptions={{ color, weight: 4, opacity: 1 }}
      positions={positions}
      eventHandlers={eventHandlers}
    />
  </>
);
